export const regularTemplate = [
  {
    technician:"Rachel" ,
    sortOrder:1,
    slots:[],
    unavailability:[]
  },
  {
    technician:"Rina" ,
    sortOrder:2,
    slots:[],
    unavailability:[]
  },
  {
    technician:"Karen",
    sortOrder:3,
    slots:[],
    unavailability:[]
  } ,
  {
    technician:"Sharon" ,
    sortOrder:4,
    slots:[],
    unavailability:[]
  }
];
